// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Noto Sans KR', sans-serif; /* A font that supports Korean and looks professional */
}

:root {
    --primary-orange: #E84200;
    --primary: #e84200;
    --dark-bg: #222222;
    --light-gray-border: #eeeeee;
    --light-gray-bg: #f7f7f7;
    --text-dark: #222222;
    --text-gray: #555555;
    --text-light-gray: #777777;
    /* autohtml 프로젝트 변수 추가 */
    --grey2: #d9d9d9;
    --grey4: #a1a1a1;
    --grey5: #727272;
    --darkgrey3: #000000;
}

.homepage {
    background-color: #fff;
}

.main-content {
    width: 100%;
    max-width: 1430px;
    margin: 0 auto;
    padding: 0 40px;
    box-sizing: border-box;
    position: relative;
    min-height: 100%;
}

/* Updated Header Styles */
.header {
    background-color: var(--dark-bg);
    color: white;
    border-bottom: 4px solid var(--primary-orange);
}

.top-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 40px;
    max-width: 1430px;
    margin: 0 auto;
    font-size: 0.9em;
}

.logo {
    font-size: 1.8em;
    font-weight: bold;
}
.logo span {
    font-weight: normal;
    font-size: 0.8em;
    margin-left: 5px;
}

.search-bar {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    padding: 0 50px;
}

.search-bar input {
    width: 100%;
    max-width: 400px;
    padding: 10px 20px;
    border: 2px solid #555;
    border-radius: 20px;
    background-color: var(--dark-bg);
    color: white;
}
.search-bar input:focus {
    border-color: var(--primary-orange);
    outline: none;
}

.search-bar button {
    background: none;
    border: none;
    color: white;
    font-size: 1.2em;
    margin-left: -40px;
    cursor: pointer;
}

.user-menu {
    display: flex;
    align-items: center;
    gap: 20px;
}
.user-menu .contact-details {
    text-align: right;
}
.user-menu .contact-details p {
    margin: 0;
    line-height: 1.4;
}
.user-menu .contact-details p:first-child {
    font-size: 0.8em;
}

.user-menu .user-icons {
    display: flex;
    gap: 15px;
    font-size: 1.5em;
    padding-left: 15px;
    border-left: 1px solid #555;
}
.user-menu .user-icons div {
    cursor: pointer;
}

.nav-bar {
    background-color: white;
    color: var(--text-dark);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    max-width: 1430px;
    margin: 0 auto;
}

.nav-links {
    display: flex;
    gap: 30px;
}
.nav-links a {
    text-decoration: none;
    color: var(--text-dark);
    padding: 15px 5px;
    font-weight: bold;
}
.nav-links a:hover, .nav-links a.active {
    color: white !important;
    border-bottom: 3px solid var(--primary-orange);
}
.nav-links a:first-child {
    font-size: 1.5em;
}
.all-menu {
    padding: 10px 20px;
    background-color: var(--primary-orange);
    color: white;
    border-radius: 5px;
    cursor: pointer;
}

/* Hero Section */
.hero-section {
    display: grid;
    grid-template-columns: 644fr 548fr; /* Adjusted proportions */
    gap: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    height: 403px; /* Fixed height */
    align-items: stretch; /* 모든 아이템이 같은 높이를 가지도록 */
}

.hero-main {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}

.hero-main img, .hero-side-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* 실제 배너 이미지가 있을 때 고정 크기 유지 */
.hero-side-item.top-right img:not([src*="placeholder"]):not([src*="data:"]),
.hero-side-item.bottom-right img:not([src*="placeholder"]):not([src*="data:"]) {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

/* 실제 배너 이미지가 있을 때 텍스트 오버레이 완전히 숨김 */
.hero-side-item.has-banner-image .hero-text {
    display: none !important;
}

.hero-side {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    height: 100%; /* hero-section 높이에 맞춤 */
    align-items: stretch; /* 모든 아이템이 같은 높이를 가지도록 */
}

.hero-side-item {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    background-color: var(--light-gray-bg);
    display: flex;
    align-items: center;
    justify-content: center;
}

.hero-side-item.top-left {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    background-color: #000;
}
.hero-side-item.top-right {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
}
.hero-side-item.bottom-right {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    background-color: transparent;
    text-align: center;
}

/* 네 번째 배너에 실제 이미지가 있을 때 배경 완전 제거 */
.hero-side-item.bottom-right.has-banner-image {
    background-color: var(--light-gray-bg) !important;

}

.hero-text {
    position: absolute;
    padding: 20px;
    color: var(--text-dark);
}

.hero-main .hero-text {
    top: 20px;
    left: 20px;
}
.hero-main .hero-text h2, .hero-main .hero-text p, .hero-main .hero-text button {
    /* These elements are not in the screenshot */
   display: none;
}


.hero-side-item.top-left .hero-text {
    bottom: 20px;
    left: 20px;
    color: white;
}
.hero-side-item.top-left h3 {
    font-size: 1.8em;
    margin: 0 0 5px 0;
}

.hero-side-item.top-right .hero-text {
    bottom: 20px;
    left: 20px;
}
.hero-side-item.top-right h4 {
    margin: 0 0 5px 0;
}


.hero-side-item.bottom-right .hero-text {
    position: static;
    color: var(--text-gray);
}


/* Features Section - autohtml-project 2026-01-27 디자인 에셋 동일 적용 */


.features-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0;
    padding: 0;
    max-width: 1400px;
    margin-bottom: 140px;
    box-sizing: border-box;
}

.features-section .feature {
    display: flex;
    flex-direction: row;
    gap: 0;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1;
    text-align: right;
    position: relative;
    padding: 0;
    max-width: none;
}

.features-section .feature .feature-title-primary {
    color: var(--primary, #e84200);
    font-family: 'Inter', 'Noto Sans KR', sans-serif;
    font-weight: 600;
}

.features-section .feature .feature-title-default {
    color: var(--darkgrey3, #000000);
    font-family: 'Inter', 'Noto Sans KR', sans-serif;
    font-weight: 500;
}

.features-section .feature h4 {
    font-size: 24px;
    font-weight: 400;
    margin: 0 0 4px 0;
    line-height: 1.2;
}

.features-section .feature p {
    color: var(--darkgrey3, #000000);
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    line-height: 1.3;
}

.features-section .feature h4 + p {
    margin-top: 4px;
}

.feature-divider {
    flex-shrink: 0;
    width: 74px;
    height: 52px;
    object-fit: none;
    object-position: center;
}

/* feature 내부를 제목+설명 세로 배치로 */
.features-section .feature {
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

/* Product Grid */
.product-grid-wrapper {
    position: relative;
    margin: 40px 0;
    display: flex;
    flex-direction: column;
    align-items: stretch; /* 그리드가 전체 너비를 차지하도록 */
    width: 100%;
}

/* grid-tit - autohtml-project 디자인 적용 */
.grid-tit,
.grid-tit * {
    box-sizing: border-box;
}

.grid-tit {
    padding: 0px 40px 0px 40px;
    display: flex;
    flex-direction: column;
    gap: 11px;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 20px;
}

.grid-tit .div {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-Bold", 'Noto Sans KR', sans-serif;
    font-size: 28px;
    font-weight: 700;
    position: relative;
    align-self: stretch;
    margin: 0;
}

.grid-tit .div2 {
    color: var(--grey5, #727272);
    text-align: center;
    font-family: "Inter-Bold", 'Noto Sans KR', sans-serif;
    font-size: 22px;
    font-weight: 700;
    position: relative;
    align-self: stretch;
    margin: 0;
}

/* 기존 product-grid-header 호환성 유지 */
.product-grid-header {
    margin-bottom: 20px;
    padding-left: 0;
    text-align: center;
}
.product-grid-header h3 {
    font-size: 1.8em;
    margin: 0;
    font-weight: bold;
}
.product-grid-header p {
    font-size: 1.1em;
    color: var(--text-gray);
    margin-top: 5px;
}


.product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    position: relative;
}

/* 제품이 없을 때 메시지 중앙 정렬 */
.product-grid > div:only-child {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 50px;
    text-align: center;
    color: #999;
}

/* 탭 섹션과 카테고리 섹션 모두 4개씩 표시 */
.tabbed-section .product-grid,
.product-grid-wrapper .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 전체 너비에 맞춰 4개 균등 분배 */
    gap: 20px; /* 4개 이미지 사이 동일한 갭 */
    align-items: flex-start;
    width: 100%; /* 탭 전체 너비와 동일 */
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.tabbed-section .product-card,
.product-grid-wrapper .product-card {
    width: 100%; /* 그리드 셀 너비에 맞춤 */
    max-width: 100%;
    flex-shrink: 0;
}

.product-card {
    border: none;
    border-radius: 15px;
    overflow: visible;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 28px;
    align-items: center;
    justify-content: flex-start;
}

.product-image-container {
    position: relative;
    background-color: white;
    width: 100%;
    height: 250px;
    border-radius: 15px;
    border: 1px solid var(--grey2, #d9d9d9);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    overflow: hidden;
}

/* 탭 섹션에서는 autohtml 프로젝트 디자인 적용 */
.tabbed-section .product-image-container {
    height: 250px;
}
.product-image-container:hover .product-actions {
    opacity: 1;
}

.product-image-container img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 15px;
    padding: 0;
    box-sizing: border-box;
}

/* SVG 플레이스홀더 스타일 */
.product-image-container .image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--light-gray-bg);
    border-radius: 15px;
}

.product-actions {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.3s;
}

.product-actions button {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    font-size: 1.2em;
    color: #555;
}

.product-info {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 13px;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}
.product-info .product-code {
    font-size: 14px;
    font-weight: 400;
    font-family: "Inter-Regular", sans-serif;
    color: var(--darkgrey3, #000000);
    text-align: center;
    margin: 0;
}
.product-info .product-title {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    font-family: "Inter-Regular", sans-serif;
    color: var(--darkgrey3, #000000);
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}
.product-info .product-subtitle {
    color: var(--grey4, #a1a1a1);
    font-size: 12px;
    font-weight: 400;
    font-family: "Inter-Regular", sans-serif;
    text-align: center;
    margin: 0;
}

/* 캐러셀 화살표 스타일 - autohtml-project 디자인 적용 */
.tabbed-section .product-grid-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch; /* 그리드가 전체 너비를 차지하도록 */
    width: 100%;
}

.tabbed-section .carousel-arrow {
    position: absolute;
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 10;
    padding: 0;
    overflow: visible;
    outline: none;
    /* 슬라이드 이미지 영역 세로 중앙 정렬 */
    top: 37%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tabbed-section .carousel-arrow:hover,
.tabbed-section .carousel-arrow:focus,
.tabbed-section .carousel-arrow:active {
    outline: none;
    border: none;
    box-shadow: none;
}

.tabbed-section .carousel-arrow img {
    width: 40px;
    height: 40px;
    display: block;
}

.tabbed-section .carousel-arrow.left img {
    transform: translate(3px, 0);
}

.tabbed-section .carousel-arrow.right img {
    transform: translate(0, 0); /* 우측 화살표 이미지 위치 조정 */
}

.tabbed-section .carousel-arrow:hover img {
    opacity: 0.8;
}

.tabbed-section .carousel-arrow.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.tabbed-section .carousel-arrow.disabled:hover img {
    opacity: 0.3;
}

.tabbed-section .carousel-arrow.left {
    left: -60px; /* 그리드 왼쪽 가장자리에서 -60px */
}

.tabbed-section .carousel-arrow.right {
    right: -60px; /* 그리드 오른쪽 가장자리에서 -60px */
    left: auto;
    transform: translateY(-50%); /* 세로 중앙 정렬 유지 */
}

/* 일반 제품 그리드의 화살표도 tabbed-section과 동일한 스타일 적용 */
.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow {
    position: absolute;
    background: none;
    border: none;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 10;
    padding: 0;
    overflow: visible;
    outline: none;
    /* 슬라이드 이미지 영역 세로 중앙 정렬 */
    top: 46%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:hover,
.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:focus,
.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:active {
    outline: none;
    border: none;
    box-shadow: none;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow img {
    width: 40px;
    height: 40px;
    display: block;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left img {
    transform: translate(3px, 0);
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right img {
    transform: translate(0px, 0);
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:hover img {
    opacity: 0.8;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.disabled:hover img {
    opacity: 0.3;
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left {
    left: -60px; /* 그리드와 동일한 간격 */
}

.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right {
    right: -60px; /* 그리드와 동일한 간격 */
    left: auto;
}


/* Tabbed Section - autohtml-project 디자인 적용 */
.tabbed-section {
    border: none;
    border-radius: 15px;
    padding: 0;
    margin: 80px 0;
    position: relative;
    background: white;
}

.tabs {
    display: flex;
    flex-direction: row;
    gap: 0;
    border-style: solid;
    border-color: var(--grey2, #d9d9d9);
    border-width: 0px 0px 1px 0px;
    padding: 0px 0px 1px 0px;
    margin-bottom: 0;
    align-self: stretch;
}

.tabs .tab-item {
    flex: 1 1;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 21px;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
}

.tabs .tab-item .tab-text {
    font-size: 28px;
    font-weight: 700;
    font-family: "Inter-Bold", sans-serif;
    color: var(--darkgrey3, #000000);
    text-align: center;
    position: relative;
    align-self: stretch;
}

.tabs .tab-item.active .tab-text {
    color: var(--primary, #e84200);
}

.tabs .tab-item .tab-border {
    background: var(--primary, #e84200);
    border-radius: 15px 15px 0px 0px;
    align-self: stretch;
    flex-shrink: 0;
    height: 15px;
    width: 100%;
    position: relative;
    opacity: 0;
}

.tabs .tab-item.active .tab-border {
    opacity: 1;
}
.tab-content {
    position: relative;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 10px;
}
.pagination span {
    font-size: 1.1em;
}


/* Bottom Banner Section */
.bottom-banner {
    margin: 80px 0;
    width: 100%;
    max-height: 265px;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.bottom-banner img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
}

.bottom-banner img:hover {
    transform: scale(1.02);
}

/* Blog Section - autohtml-project 디자인 적용 */
.blog-section {
    margin: 80px 0;
    background-color: white;
    padding: 0; /* 데스크탑에서 패딩 0 */
    border-radius: 0;
    overflow: visible;
    max-width: 1430px;
    margin-left: auto;
    margin-right: auto;
}

.blog-content {
    display: flex;
    flex-direction: row;
    gap: 38px;
    align-items: center;
    justify-content: flex-start;
    min-height: 265px;
    width: 100%;
}

.blog-text-content {
    display: flex;
    flex-direction: row;
    gap: 21px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    padding: 0;
}

.blog-text-content h2 {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-Bold", sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.4;
    margin: 0;
}

.blog-arrow-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    flex-shrink: 0;
    position: relative;
}

.blog-arrow-btn::after {
    content: '';
    width: 12px;
    height: 12px;
    border-right: 3px solid var(--primary, #e84200);
    border-top: 3px solid var(--primary, #e84200);
    transform: rotate(45deg);
    display: block;
    position: absolute;
}

.blog-arrow-btn:hover {
    transform: translateX(5px);
}

.blog-arrow-btn:hover::after {
    border-right-color: var(--primary, #e84200);
    border-top-color: var(--primary, #e84200);
}

.blog-image-content {
    position: relative;
    flex: 1 1;
    min-width: 0;
    height: 360px; /* 데스크탑에서 높이 360px */
    background-color: white;
    border-radius: 0;
    overflow: hidden;
    margin-right: 0;
}

.blog-image-content img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: white;
    position: absolute;
    left: 0;
    top: 0;
}

.blog-badge {
    position: absolute;
    left: 608px;
    top: 175px;
    display: none; /* 데스크탑에서 숨김 */
    flex-direction: row;
    gap: 10px;
    align-items: flex-end;
    justify-content: flex-start;
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
}

.blog-badge .frame-1707482016 {
    padding: 7px 0;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
}

.blog-badge .frame-1707482014 {
    flex-shrink: 0;
    width: 88px;
    height: 80px;
    position: relative;
}

.naver-icon {
    display: none; /* SVG로 대체 */
}

.blog-text {
    color: var(--white, #ffffff);
    text-align: left;
    font-family: "Inter-Bold", sans-serif;
    font-size: 22px;
    font-weight: 700;
    margin: 0;
}

.blog-badge img {
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    overflow: visible;
    width: 88px;
    height: 80px;
}


/* Footer */
.footer {
    background-color: var(--dark-bg);
    color: #ccc;
    padding: 50px 0;
    font-size: 0.9em;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 1430px;
    margin: 0 auto;
    padding: 0 40px;
}

.footer-info {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.footer-logo {
    color: white;
    font-size: 1.8em;
    font-weight: bold;
    margin-top: -10px;
}
.footer-logo span {
     font-weight: normal;
}

.footer-text h4 {
    font-size: 1.2em;
    margin: 0 0 15px 0;
    color: white;
}

.footer-text p {
    margin: 5px 0;
    line-height: 1.6;
}

.footer-links {
    text-align: right;
}

.policy-links {
    margin-bottom: 20px;
}

.policy-links a {
    color: #ccc;
    text-decoration: none;
    font-weight: bold;
}
.policy-links a:hover {
    color: white;
}

.policy-links span {
    margin: 0 10px;
    color: #555;
}

.contact-info p {
    margin: 5px 0;
    font-size: 14px;
    color: #ccc;
    line-height: 1.8;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .main-content {
        padding: 0 20px;
    }

    .search-bar {
        padding: 0 20px;
    }
    
    .nav-links {
        gap: 20px;
    }

    .hero-section {
        grid-template-columns: 1fr;
        height: auto;
    }

    .hero-side {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
    }
    .hero-side-item.top-left {
        grid-column: 1 / 3;
        grid-row: 1 / 2;
        height: 300px;
    }
     .hero-side-item.top-right {
        grid-column: 1 / 2;
        grid-row: 2 / 3;
    }
    .hero-side-item.bottom-right {
        grid-column: 2 / 3;
        grid-row: 2 / 3;
    }

    .product-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    /* 블로그 섹션 태블릿 */
    .blog-text-content {
        padding: 35px 40px;
    }

    .blog-text-content h2 {
        font-size: 22px;
    }

    .blog-image-content {
        width: 400px;
        height: 180px;
        margin-right: 15px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .main-content {
        padding: 0 15px;
    }

    .top-header, .nav-bar {
        padding: 10px 15px;
    }
    
    .search-bar {
        display: none; /* Often replaced by an icon in mobile view */
    }

    .user-menu .contact-details {
        display: none;
    }
    
    .nav-links {
        display: none; /* Hamburger menu would control this */
    }
    
    .all-menu {
        display: none; /* Hamburger menu would control this */
    }

    .hero-side {
        grid-template-columns: 1fr;
    }

    .hero-side-item.top-left,
    .hero-side-item.top-right,
    .hero-side-item.bottom-right {
        grid-column: 1 / 2;
    }
    
    /* 모바일에서 실제 배너 이미지 크기 조정 */
    .hero-side-item.top-right img:not([src*="placeholder"]):not([src*="data:"]),
    .hero-side-item.bottom-right img:not([src*="placeholder"]):not([src*="data:"]) {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
    }
    
    /* 모바일에서도 실제 배너 이미지가 있을 때 텍스트 숨김 */
    .hero-side-item.has-banner-image .hero-text {
        display: none !important;
    }
    
     .hero-side-item.top-left {
        grid-row: auto;
    }
     .hero-side-item.top-right {
        grid-row: auto;
    }
    .hero-side-item.bottom-right {
        grid-row: auto;
    }

    .features-section {
        flex-direction: column;
        gap: 30px;
        align-items: center;
        justify-content: center;
        padding: 20px 15px;
    }

    .features-section .feature-divider {
        display: none;
    }
    
    .features-section .feature {
        max-width: 100%;
        width: 100%;
        padding: 0 15px;
        text-align: center;
        align-items: center;
    }

    .product-grid-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    /* 블로그 섹션 반응형 */
    .blog-section {
        padding: 0 15px;
    }

    .blog-content {
        flex-direction: column;
        gap: 20px;
        min-height: auto;
    }

    .blog-text-content {
        padding: 0;
        text-align: center;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .blog-text-content h2 {
        font-size: 20px;
        text-align: center;
    }

    .blog-arrow-btn {
        font-size: 32px;
        width: 32px;
        height: 32px;
    }

    .blog-image-content {
        width: 100%;
        height: 200px;
        margin-right: 0;
        margin-top: 0;
    }

    .blog-badge {
        left: auto;
        right: 15px;
        top: auto;
        bottom: 15px;
    }

    .blog-text {
        font-size: 16px;
    }

    .blog-badge .frame-1707482014 {
        width: 60px;
        height: 60px;
    }

    .blog-badge img {
        width: 60px;
        height: 60px;
    }
    
    .product-grid,
    .tabbed-section .product-grid,
    .product-grid-wrapper .product-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }

    .tabs {
        flex-wrap: wrap;
    }
    
    .tabs .tab-item .tab-text {
        font-size: 16px;
    }
    
    .product-grid-header h3 {
        font-size: 20px;
    }
    
    .product-grid-header p {
        font-size: 14px;
    }

    /* grid-tit 모바일 반응형 */
    .grid-tit {
        padding: 0px 15px 0px 15px;
        gap: 8px;
    }

    .grid-tit .div {
        font-size: 22px;
    }

    .grid-tit .div2 {
        font-size: 18px;
    }
    
    /* 모바일에서 화살표를 그리드 안쪽에 표시 */
    .tabbed-section .carousel-arrow.left {
        left: 10px;
    }
    
    .tabbed-section .carousel-arrow.right {
        right: 10px;
        left: auto;
    }
    
    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left {
        left: 10px;
    }
    
    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right {
        right: 10px;
        left: auto;
    }
    
    .tabbed-section .carousel-arrow,
    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow {
        width: 30px;
        height: 30px;
        top: 50%;
        transform: translateY(-50%);
    }
    
    .tabbed-section .carousel-arrow img,
    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow img {
        width: 30px;
        height: 30px;
    }
    
    .bottom-banner {
        max-height: 200px; /* Adjust for smaller screens */
        margin: 40px 0; /* Reduce margin on mobile */
        border-radius: 4px; /* Smaller border radius for mobile */
    }
    
    .bottom-banner img {
        object-fit: cover; /* Ensure proper image cropping on mobile */
    }
    
    .blog-section {
        flex-direction: column;
        padding: 20px;
        margin: 40px 0;
    }
    
    .blog-text {
        padding-right: 0;
        text-align: center;
        margin-bottom: 20px;
    }
    
    .blog-image {
        margin-right: 0;
    }

    .footer-content {
        flex-direction: column;
        gap: 30px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/HomePage.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC,EAAE,uDAAuD;AACpG;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,gCAAgC;IAChC,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,kCAAkC,EAAE,yBAAyB;IAC7D,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,aAAa,EAAE,iBAAiB;IAChC,oBAAoB,EAAE,wBAAwB;AAClD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,SAAS;IACT,YAAY,EAAE,wBAAwB;IACtC,oBAAoB,EAAE,wBAAwB;AAClD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,iDAAiD;;AAErD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,6CAA6C;GAC9C,aAAa;AAChB;;;AAGA;IACI,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA,gEAAgE;;;AAGhE;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,MAAM;IACN,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAE,sBAAsB;IAC5C,WAAW;AACf;;AAEA,uCAAuC;AACvC;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,qDAAqD;IACrD,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,qDAAqD;IACrD,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA,kCAAkC;AAClC;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA,4BAA4B;AAC5B;;IAEI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;IAC9D,SAAS,EAAE,oBAAoB;IAC/B,uBAAuB;IACvB,WAAW,EAAE,gBAAgB;IAC7B,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW,EAAE,iBAAiB;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,SAAS;AACb;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAE,sBAAsB;IAC5C,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B,EAAE,qBAAqB;AACrD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW,EAAE,wBAAwB;AACzC;;AAEA;IACI,YAAY,EAAE,yBAAyB;IACvC,UAAU;IACV,2BAA2B,EAAE,gBAAgB;AACjD;;AAEA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW,EAAE,gBAAgB;AACjC;;AAEA;IACI,YAAY,EAAE,gBAAgB;IAC9B,UAAU;AACd;;;AAGA,6CAA6C;AAC7C;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,mBAAmB;IACnB,mCAAmC;IACnC,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;;AAGA,0BAA0B;AAC1B;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,uBAAuB;IACvB,UAAU,EAAE,gBAAgB;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,6CAA6C;IAC7C,wBAAwB;IACxB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,YAAY;IACZ,aAAa,EAAE,oBAAoB;IACnC,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,aAAa,EAAE,cAAc;IAC7B,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa,EAAE,YAAY;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;;AAGA,WAAW;AACX;IACI,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;KACK,mBAAmB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,8BAA8B;QAC9B,wBAAwB;IAC5B;IACA;QACI,kBAAkB;QAClB,eAAe;QACf,aAAa;IACjB;KACC;QACG,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA,eAAe;IACf;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa,EAAE,6CAA6C;IAChE;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa,EAAE,sCAAsC;IACzD;;IAEA;QACI,aAAa,EAAE,sCAAsC;IACzD;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,kBAAkB;IACtB;;IAEA,0BAA0B;IAC1B;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;IAClC;;IAEA,kCAAkC;IAClC;QACI,wBAAwB;IAC5B;;KAEC;QACG,cAAc;IAClB;KACC;QACG,cAAc;IAClB;IACA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA,eAAe;IACf;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;;QAGI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,qBAAqB;IACrB;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,0BAA0B;IAC1B;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,2BAA2B;IAC/B;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB,EAAE,+BAA+B;QAClD,cAAc,EAAE,4BAA4B;QAC5C,kBAAkB,EAAE,qCAAqC;IAC7D;;IAEA;QACI,iBAAiB,EAAE,2CAA2C;IAClE;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":["body {\n    font-family: 'Noto Sans KR', sans-serif; /* A font that supports Korean and looks professional */\n}\n\n:root {\n    --primary-orange: #E84200;\n    --primary: #e84200;\n    --dark-bg: #222222;\n    --light-gray-border: #eeeeee;\n    --light-gray-bg: #f7f7f7;\n    --text-dark: #222222;\n    --text-gray: #555555;\n    --text-light-gray: #777777;\n    /* autohtml 프로젝트 변수 추가 */\n    --grey2: #d9d9d9;\n    --grey4: #a1a1a1;\n    --grey5: #727272;\n    --darkgrey3: #000000;\n}\n\n.homepage {\n    background-color: #fff;\n}\n\n.main-content {\n    width: 100%;\n    max-width: 1430px;\n    margin: 0 auto;\n    padding: 0 40px;\n    box-sizing: border-box;\n    position: relative;\n    min-height: 100%;\n}\n\n/* Updated Header Styles */\n.header {\n    background-color: var(--dark-bg);\n    color: white;\n    border-bottom: 4px solid var(--primary-orange);\n}\n\n.top-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 40px;\n    max-width: 1430px;\n    margin: 0 auto;\n    font-size: 0.9em;\n}\n\n.logo {\n    font-size: 1.8em;\n    font-weight: bold;\n}\n.logo span {\n    font-weight: normal;\n    font-size: 0.8em;\n    margin-left: 5px;\n}\n\n.search-bar {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    padding: 0 50px;\n}\n\n.search-bar input {\n    width: 100%;\n    max-width: 400px;\n    padding: 10px 20px;\n    border: 2px solid #555;\n    border-radius: 20px;\n    background-color: var(--dark-bg);\n    color: white;\n}\n.search-bar input:focus {\n    border-color: var(--primary-orange);\n    outline: none;\n}\n\n.search-bar button {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 1.2em;\n    margin-left: -40px;\n    cursor: pointer;\n}\n\n.user-menu {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n.user-menu .contact-details {\n    text-align: right;\n}\n.user-menu .contact-details p {\n    margin: 0;\n    line-height: 1.4;\n}\n.user-menu .contact-details p:first-child {\n    font-size: 0.8em;\n}\n\n.user-menu .user-icons {\n    display: flex;\n    gap: 15px;\n    font-size: 1.5em;\n    padding-left: 15px;\n    border-left: 1px solid #555;\n}\n.user-menu .user-icons div {\n    cursor: pointer;\n}\n\n.nav-bar {\n    background-color: white;\n    color: var(--text-dark);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 40px;\n    max-width: 1430px;\n    margin: 0 auto;\n}\n\n.nav-links {\n    display: flex;\n    gap: 30px;\n}\n.nav-links a {\n    text-decoration: none;\n    color: var(--text-dark);\n    padding: 15px 5px;\n    font-weight: bold;\n}\n.nav-links a:hover, .nav-links a.active {\n    color: white !important;\n    border-bottom: 3px solid var(--primary-orange);\n}\n.nav-links a:first-child {\n    font-size: 1.5em;\n}\n.all-menu {\n    padding: 10px 20px;\n    background-color: var(--primary-orange);\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n/* Hero Section */\n.hero-section {\n    display: grid;\n    grid-template-columns: 644fr 548fr; /* Adjusted proportions */\n    gap: 20px;\n    margin-top: 40px;\n    margin-bottom: 40px;\n    height: 403px; /* Fixed height */\n    align-items: stretch; /* 모든 아이템이 같은 높이를 가지도록 */\n}\n\n.hero-main {\n    position: relative;\n    border-radius: 15px;\n    overflow: hidden;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hero-main img, .hero-side-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n/* 실제 배너 이미지가 있을 때 고정 크기 유지 */\n.hero-side-item.top-right img:not([src*=\"placeholder\"]):not([src*=\"data:\"]),\n.hero-side-item.bottom-right img:not([src*=\"placeholder\"]):not([src*=\"data:\"]) {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: contain;\n    display: block;\n    margin: 0 auto;\n}\n\n/* 실제 배너 이미지가 있을 때 텍스트 오버레이 완전히 숨김 */\n.hero-side-item.has-banner-image .hero-text {\n    display: none !important;\n}\n\n.hero-side {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n    gap: 20px;\n    height: 100%; /* hero-section 높이에 맞춤 */\n    align-items: stretch; /* 모든 아이템이 같은 높이를 가지도록 */\n}\n\n.hero-side-item {\n    position: relative;\n    border-radius: 15px;\n    overflow: hidden;\n    background-color: var(--light-gray-bg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hero-side-item.top-left {\n    grid-column: 1 / 2;\n    grid-row: 1 / 3;\n    background-color: #000;\n}\n.hero-side-item.top-right {\n    grid-column: 2 / 3;\n    grid-row: 1 / 2;\n}\n.hero-side-item.bottom-right {\n    grid-column: 2 / 3;\n    grid-row: 2 / 3;\n    background-color: transparent;\n    text-align: center;\n}\n\n/* 네 번째 배너에 실제 이미지가 있을 때 배경 완전 제거 */\n.hero-side-item.bottom-right.has-banner-image {\n    background-color: var(--light-gray-bg) !important;\n\n}\n\n.hero-text {\n    position: absolute;\n    padding: 20px;\n    color: var(--text-dark);\n}\n\n.hero-main .hero-text {\n    top: 20px;\n    left: 20px;\n}\n.hero-main .hero-text h2, .hero-main .hero-text p, .hero-main .hero-text button {\n    /* These elements are not in the screenshot */\n   display: none;\n}\n\n\n.hero-side-item.top-left .hero-text {\n    bottom: 20px;\n    left: 20px;\n    color: white;\n}\n.hero-side-item.top-left h3 {\n    font-size: 1.8em;\n    margin: 0 0 5px 0;\n}\n\n.hero-side-item.top-right .hero-text {\n    bottom: 20px;\n    left: 20px;\n}\n.hero-side-item.top-right h4 {\n    margin: 0 0 5px 0;\n}\n\n\n.hero-side-item.bottom-right .hero-text {\n    position: static;\n    color: var(--text-gray);\n}\n\n\n/* Features Section - autohtml-project 2026-01-27 디자인 에셋 동일 적용 */\n\n\n.features-section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0;\n    padding: 0;\n    max-width: 1400px;\n    margin-bottom: 140px;\n    box-sizing: border-box;\n}\n\n.features-section .feature {\n    display: flex;\n    flex-direction: row;\n    gap: 0;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 1;\n    text-align: right;\n    position: relative;\n    padding: 0;\n    max-width: none;\n}\n\n.features-section .feature .feature-title-primary {\n    color: var(--primary, #e84200);\n    font-family: 'Inter', 'Noto Sans KR', sans-serif;\n    font-weight: 600;\n}\n\n.features-section .feature .feature-title-default {\n    color: var(--darkgrey3, #000000);\n    font-family: 'Inter', 'Noto Sans KR', sans-serif;\n    font-weight: 500;\n}\n\n.features-section .feature h4 {\n    font-size: 24px;\n    font-weight: 400;\n    margin: 0 0 4px 0;\n    line-height: 1.2;\n}\n\n.features-section .feature p {\n    color: var(--darkgrey3, #000000);\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n    line-height: 1.3;\n}\n\n.features-section .feature h4 + p {\n    margin-top: 4px;\n}\n\n.feature-divider {\n    flex-shrink: 0;\n    width: 74px;\n    height: 52px;\n    object-fit: none;\n    object-position: center;\n}\n\n/* feature 내부를 제목+설명 세로 배치로 */\n.features-section .feature {\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n}\n\n/* Product Grid */\n.product-grid-wrapper {\n    position: relative;\n    margin: 40px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch; /* 그리드가 전체 너비를 차지하도록 */\n    width: 100%;\n}\n\n/* grid-tit - autohtml-project 디자인 적용 */\n.grid-tit,\n.grid-tit * {\n    box-sizing: border-box;\n}\n\n.grid-tit {\n    padding: 0px 40px 0px 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    margin-bottom: 20px;\n}\n\n.grid-tit .div {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-Bold\", 'Noto Sans KR', sans-serif;\n    font-size: 28px;\n    font-weight: 700;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n.grid-tit .div2 {\n    color: var(--grey5, #727272);\n    text-align: center;\n    font-family: \"Inter-Bold\", 'Noto Sans KR', sans-serif;\n    font-size: 22px;\n    font-weight: 700;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n/* 기존 product-grid-header 호환성 유지 */\n.product-grid-header {\n    margin-bottom: 20px;\n    padding-left: 0;\n    text-align: center;\n}\n.product-grid-header h3 {\n    font-size: 1.8em;\n    margin: 0;\n    font-weight: bold;\n}\n.product-grid-header p {\n    font-size: 1.1em;\n    color: var(--text-gray);\n    margin-top: 5px;\n}\n\n\n.product-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 30px;\n    position: relative;\n}\n\n/* 제품이 없을 때 메시지 중앙 정렬 */\n.product-grid > div:only-child {\n    grid-column: 1 / -1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    padding: 50px;\n    text-align: center;\n    color: #999;\n}\n\n/* 탭 섹션과 카테고리 섹션 모두 4개씩 표시 */\n.tabbed-section .product-grid,\n.product-grid-wrapper .product-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr); /* 전체 너비에 맞춰 4개 균등 분배 */\n    gap: 20px; /* 4개 이미지 사이 동일한 갭 */\n    align-items: flex-start;\n    width: 100%; /* 탭 전체 너비와 동일 */\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.tabbed-section .product-card,\n.product-grid-wrapper .product-card {\n    width: 100%; /* 그리드 셀 너비에 맞춤 */\n    max-width: 100%;\n    flex-shrink: 0;\n}\n\n.product-card {\n    border: none;\n    border-radius: 15px;\n    overflow: visible;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.product-image-container {\n    position: relative;\n    background-color: white;\n    width: 100%;\n    height: 250px;\n    border-radius: 15px;\n    border: 1px solid var(--grey2, #d9d9d9);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n    overflow: hidden;\n}\n\n/* 탭 섹션에서는 autohtml 프로젝트 디자인 적용 */\n.tabbed-section .product-image-container {\n    height: 250px;\n}\n.product-image-container:hover .product-actions {\n    opacity: 1;\n}\n\n.product-image-container img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 15px;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* SVG 플레이스홀더 스타일 */\n.product-image-container .image-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--light-gray-bg);\n    border-radius: 15px;\n}\n\n.product-actions {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.product-actions button {\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #ddd;\n    background-color: white;\n    cursor: pointer;\n    font-size: 1.2em;\n    color: #555;\n}\n\n.product-info {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 13px;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n}\n.product-info .product-code {\n    font-size: 14px;\n    font-weight: 400;\n    font-family: \"Inter-Regular\", sans-serif;\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    margin: 0;\n}\n.product-info .product-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: \"Inter-Regular\", sans-serif;\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n}\n.product-info .product-subtitle {\n    color: var(--grey4, #a1a1a1);\n    font-size: 12px;\n    font-weight: 400;\n    font-family: \"Inter-Regular\", sans-serif;\n    text-align: center;\n    margin: 0;\n}\n\n/* 캐러셀 화살표 스타일 - autohtml-project 디자인 적용 */\n.tabbed-section .product-grid-wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch; /* 그리드가 전체 너비를 차지하도록 */\n    width: 100%;\n}\n\n.tabbed-section .carousel-arrow {\n    position: absolute;\n    background: none;\n    border: none;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    z-index: 10;\n    padding: 0;\n    overflow: visible;\n    outline: none;\n    /* 슬라이드 이미지 영역 세로 중앙 정렬 */\n    top: 37%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tabbed-section .carousel-arrow:hover,\n.tabbed-section .carousel-arrow:focus,\n.tabbed-section .carousel-arrow:active {\n    outline: none;\n    border: none;\n    box-shadow: none;\n}\n\n.tabbed-section .carousel-arrow img {\n    width: 40px;\n    height: 40px;\n    display: block;\n}\n\n.tabbed-section .carousel-arrow.left img {\n    transform: translate(3px, 0);\n}\n\n.tabbed-section .carousel-arrow.right img {\n    transform: translate(0, 0); /* 우측 화살표 이미지 위치 조정 */\n}\n\n.tabbed-section .carousel-arrow:hover img {\n    opacity: 0.8;\n}\n\n.tabbed-section .carousel-arrow.disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.tabbed-section .carousel-arrow.disabled:hover img {\n    opacity: 0.3;\n}\n\n.tabbed-section .carousel-arrow.left {\n    left: -60px; /* 그리드 왼쪽 가장자리에서 -60px */\n}\n\n.tabbed-section .carousel-arrow.right {\n    right: -60px; /* 그리드 오른쪽 가장자리에서 -60px */\n    left: auto;\n    transform: translateY(-50%); /* 세로 중앙 정렬 유지 */\n}\n\n/* 일반 제품 그리드의 화살표도 tabbed-section과 동일한 스타일 적용 */\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow {\n    position: absolute;\n    background: none;\n    border: none;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    z-index: 10;\n    padding: 0;\n    overflow: visible;\n    outline: none;\n    /* 슬라이드 이미지 영역 세로 중앙 정렬 */\n    top: 46%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:hover,\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:focus,\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:active {\n    outline: none;\n    border: none;\n    box-shadow: none;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow img {\n    width: 40px;\n    height: 40px;\n    display: block;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left img {\n    transform: translate(3px, 0);\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right img {\n    transform: translate(0px, 0);\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow:hover img {\n    opacity: 0.8;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.disabled:hover img {\n    opacity: 0.3;\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left {\n    left: -60px; /* 그리드와 동일한 간격 */\n}\n\n.product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right {\n    right: -60px; /* 그리드와 동일한 간격 */\n    left: auto;\n}\n\n\n/* Tabbed Section - autohtml-project 디자인 적용 */\n.tabbed-section {\n    border: none;\n    border-radius: 15px;\n    padding: 0;\n    margin: 80px 0;\n    position: relative;\n    background: white;\n}\n\n.tabs {\n    display: flex;\n    flex-direction: row;\n    gap: 0;\n    border-style: solid;\n    border-color: var(--grey2, #d9d9d9);\n    border-width: 0px 0px 1px 0px;\n    padding: 0px 0px 1px 0px;\n    margin-bottom: 0;\n    align-self: stretch;\n}\n\n.tabs .tab-item {\n    flex: 1;\n    padding: 0;\n    border: none;\n    background: none;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 21px;\n    align-items: center;\n    justify-content: flex-start;\n    align-self: stretch;\n}\n\n.tabs .tab-item .tab-text {\n    font-size: 28px;\n    font-weight: 700;\n    font-family: \"Inter-Bold\", sans-serif;\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    position: relative;\n    align-self: stretch;\n}\n\n.tabs .tab-item.active .tab-text {\n    color: var(--primary, #e84200);\n}\n\n.tabs .tab-item .tab-border {\n    background: var(--primary, #e84200);\n    border-radius: 15px 15px 0px 0px;\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 15px;\n    width: 100%;\n    position: relative;\n    opacity: 0;\n}\n\n.tabs .tab-item.active .tab-border {\n    opacity: 1;\n}\n.tab-content {\n    position: relative;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n    gap: 10px;\n}\n.pagination span {\n    font-size: 1.1em;\n}\n\n\n/* Bottom Banner Section */\n.bottom-banner {\n    margin: 80px 0;\n    width: 100%;\n    max-height: 265px;\n    overflow: hidden;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.bottom-banner img {\n    width: 100%;\n    height: auto;\n    display: block;\n    transition: transform 0.3s ease;\n}\n\n.bottom-banner img:hover {\n    transform: scale(1.02);\n}\n\n/* Blog Section - autohtml-project 디자인 적용 */\n.blog-section {\n    margin: 80px 0;\n    background-color: white;\n    padding: 0; /* 데스크탑에서 패딩 0 */\n    border-radius: 0;\n    overflow: visible;\n    max-width: 1430px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.blog-content {\n    display: flex;\n    flex-direction: row;\n    gap: 38px;\n    align-items: center;\n    justify-content: flex-start;\n    min-height: 265px;\n    width: 100%;\n}\n\n.blog-text-content {\n    display: flex;\n    flex-direction: row;\n    gap: 21px;\n    align-items: center;\n    justify-content: flex-start;\n    flex-shrink: 0;\n    padding: 0;\n}\n\n.blog-text-content h2 {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1.4;\n    margin: 0;\n}\n\n.blog-arrow-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s ease;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.blog-arrow-btn::after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    border-right: 3px solid var(--primary, #e84200);\n    border-top: 3px solid var(--primary, #e84200);\n    transform: rotate(45deg);\n    display: block;\n    position: absolute;\n}\n\n.blog-arrow-btn:hover {\n    transform: translateX(5px);\n}\n\n.blog-arrow-btn:hover::after {\n    border-right-color: var(--primary, #e84200);\n    border-top-color: var(--primary, #e84200);\n}\n\n.blog-image-content {\n    position: relative;\n    flex: 1;\n    min-width: 0;\n    height: 360px; /* 데스크탑에서 높이 360px */\n    background-color: white;\n    border-radius: 0;\n    overflow: hidden;\n    margin-right: 0;\n}\n\n.blog-image-content img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    background-color: white;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.blog-badge {\n    position: absolute;\n    left: 608px;\n    top: 175px;\n    display: none; /* 데스크탑에서 숨김 */\n    flex-direction: row;\n    gap: 10px;\n    align-items: flex-end;\n    justify-content: flex-start;\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n    box-shadow: none;\n}\n\n.blog-badge .frame-1707482016 {\n    padding: 7px 0;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.blog-badge .frame-1707482014 {\n    flex-shrink: 0;\n    width: 88px;\n    height: 80px;\n    position: relative;\n}\n\n.naver-icon {\n    display: none; /* SVG로 대체 */\n}\n\n.blog-text {\n    color: var(--white, #ffffff);\n    text-align: left;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.blog-badge img {\n    height: auto;\n    position: absolute;\n    left: 0;\n    top: 0;\n    overflow: visible;\n    width: 88px;\n    height: 80px;\n}\n\n\n/* Footer */\n.footer {\n    background-color: var(--dark-bg);\n    color: #ccc;\n    padding: 50px 0;\n    font-size: 0.9em;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    max-width: 1430px;\n    margin: 0 auto;\n    padding: 0 40px;\n}\n\n.footer-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n}\n\n.footer-logo {\n    color: white;\n    font-size: 1.8em;\n    font-weight: bold;\n    margin-top: -10px;\n}\n.footer-logo span {\n     font-weight: normal;\n}\n\n.footer-text h4 {\n    font-size: 1.2em;\n    margin: 0 0 15px 0;\n    color: white;\n}\n\n.footer-text p {\n    margin: 5px 0;\n    line-height: 1.6;\n}\n\n.footer-links {\n    text-align: right;\n}\n\n.policy-links {\n    margin-bottom: 20px;\n}\n\n.policy-links a {\n    color: #ccc;\n    text-decoration: none;\n    font-weight: bold;\n}\n.policy-links a:hover {\n    color: white;\n}\n\n.policy-links span {\n    margin: 0 10px;\n    color: #555;\n}\n\n.contact-info p {\n    margin: 5px 0;\n    font-size: 14px;\n    color: #ccc;\n    line-height: 1.8;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .main-content {\n        padding: 0 20px;\n    }\n\n    .search-bar {\n        padding: 0 20px;\n    }\n    \n    .nav-links {\n        gap: 20px;\n    }\n\n    .hero-section {\n        grid-template-columns: 1fr;\n        height: auto;\n    }\n\n    .hero-side {\n        grid-template-columns: 1fr 1fr;\n        grid-template-rows: auto;\n    }\n    .hero-side-item.top-left {\n        grid-column: 1 / 3;\n        grid-row: 1 / 2;\n        height: 300px;\n    }\n     .hero-side-item.top-right {\n        grid-column: 1 / 2;\n        grid-row: 2 / 3;\n    }\n    .hero-side-item.bottom-right {\n        grid-column: 2 / 3;\n        grid-row: 2 / 3;\n    }\n\n    .product-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    /* 블로그 섹션 태블릿 */\n    .blog-text-content {\n        padding: 35px 40px;\n    }\n\n    .blog-text-content h2 {\n        font-size: 22px;\n    }\n\n    .blog-image-content {\n        width: 400px;\n        height: 180px;\n        margin-right: 15px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .main-content {\n        padding: 0 15px;\n    }\n\n    .top-header, .nav-bar {\n        padding: 10px 15px;\n    }\n    \n    .search-bar {\n        display: none; /* Often replaced by an icon in mobile view */\n    }\n\n    .user-menu .contact-details {\n        display: none;\n    }\n    \n    .nav-links {\n        display: none; /* Hamburger menu would control this */\n    }\n    \n    .all-menu {\n        display: none; /* Hamburger menu would control this */\n    }\n\n    .hero-side {\n        grid-template-columns: 1fr;\n    }\n\n    .hero-side-item.top-left,\n    .hero-side-item.top-right,\n    .hero-side-item.bottom-right {\n        grid-column: 1 / 2;\n    }\n    \n    /* 모바일에서 실제 배너 이미지 크기 조정 */\n    .hero-side-item.top-right img:not([src*=\"placeholder\"]):not([src*=\"data:\"]),\n    .hero-side-item.bottom-right img:not([src*=\"placeholder\"]):not([src*=\"data:\"]) {\n        width: 100% !important;\n        height: 100% !important;\n        object-fit: contain !important;\n    }\n    \n    /* 모바일에서도 실제 배너 이미지가 있을 때 텍스트 숨김 */\n    .hero-side-item.has-banner-image .hero-text {\n        display: none !important;\n    }\n    \n     .hero-side-item.top-left {\n        grid-row: auto;\n    }\n     .hero-side-item.top-right {\n        grid-row: auto;\n    }\n    .hero-side-item.bottom-right {\n        grid-row: auto;\n    }\n\n    .features-section {\n        flex-direction: column;\n        gap: 30px;\n        align-items: center;\n        justify-content: center;\n        padding: 20px 15px;\n    }\n\n    .features-section .feature-divider {\n        display: none;\n    }\n    \n    .features-section .feature {\n        max-width: 100%;\n        width: 100%;\n        padding: 0 15px;\n        text-align: center;\n        align-items: center;\n    }\n\n    .product-grid-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    /* 블로그 섹션 반응형 */\n    .blog-section {\n        padding: 0 15px;\n    }\n\n    .blog-content {\n        flex-direction: column;\n        gap: 20px;\n        min-height: auto;\n    }\n\n    .blog-text-content {\n        padding: 0;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .blog-text-content h2 {\n        font-size: 20px;\n        text-align: center;\n    }\n\n    .blog-arrow-btn {\n        font-size: 32px;\n        width: 32px;\n        height: 32px;\n    }\n\n    .blog-image-content {\n        width: 100%;\n        height: 200px;\n        margin-right: 0;\n        margin-top: 0;\n    }\n\n    .blog-badge {\n        left: auto;\n        right: 15px;\n        top: auto;\n        bottom: 15px;\n    }\n\n    .blog-text {\n        font-size: 16px;\n    }\n\n    .blog-badge .frame-1707482014 {\n        width: 60px;\n        height: 60px;\n    }\n\n    .blog-badge img {\n        width: 60px;\n        height: 60px;\n    }\n    \n    .product-grid,\n    .tabbed-section .product-grid,\n    .product-grid-wrapper .product-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 15px;\n    }\n\n    .tabs {\n        flex-wrap: wrap;\n    }\n    \n    .tabs .tab-item .tab-text {\n        font-size: 16px;\n    }\n    \n    .product-grid-header h3 {\n        font-size: 20px;\n    }\n    \n    .product-grid-header p {\n        font-size: 14px;\n    }\n\n    /* grid-tit 모바일 반응형 */\n    .grid-tit {\n        padding: 0px 15px 0px 15px;\n        gap: 8px;\n    }\n\n    .grid-tit .div {\n        font-size: 22px;\n    }\n\n    .grid-tit .div2 {\n        font-size: 18px;\n    }\n    \n    /* 모바일에서 화살표를 그리드 안쪽에 표시 */\n    .tabbed-section .carousel-arrow.left {\n        left: 10px;\n    }\n    \n    .tabbed-section .carousel-arrow.right {\n        right: 10px;\n        left: auto;\n    }\n    \n    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.left {\n        left: 10px;\n    }\n    \n    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow.right {\n        right: 10px;\n        left: auto;\n    }\n    \n    .tabbed-section .carousel-arrow,\n    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow {\n        width: 30px;\n        height: 30px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n    \n    .tabbed-section .carousel-arrow img,\n    .product-grid-wrapper:not(.tabbed-section .product-grid-wrapper) .carousel-arrow img {\n        width: 30px;\n        height: 30px;\n    }\n    \n    .bottom-banner {\n        max-height: 200px; /* Adjust for smaller screens */\n        margin: 40px 0; /* Reduce margin on mobile */\n        border-radius: 4px; /* Smaller border radius for mobile */\n    }\n    \n    .bottom-banner img {\n        object-fit: cover; /* Ensure proper image cropping on mobile */\n    }\n    \n    .blog-section {\n        flex-direction: column;\n        padding: 20px;\n        margin: 40px 0;\n    }\n    \n    .blog-text {\n        padding-right: 0;\n        text-align: center;\n        margin-bottom: 20px;\n    }\n    \n    .blog-image {\n        margin-right: 0;\n    }\n\n    .footer-content {\n        flex-direction: column;\n        gap: 30px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
